import { useEffect } from 'react'
import ReactGA from 'react-ga4'

const GOOGLE_ANALYTICS_ID_PROD = 'G-Q003PPV42B'
const GOOGLE_ANALYTICS_ID_TEST = 'G-CY9T0DVEM7'

const getEnvironment = (): string => {
  return (window as any)?.env?.APP_ENVIRONMENT || 'development'
}

const isProduction = (): boolean => {
  return getEnvironment() === 'prod-bo01'
}

export const useGoogleAnalytics = (): void => {
  useEffect(() => {
    const environment = getEnvironment()
    const trackingId = isProduction() ? GOOGLE_ANALYTICS_ID_PROD : GOOGLE_ANALYTICS_ID_TEST
    const isDebugMode = !isProduction()

    ReactGA.initialize([
      {
        trackingId,
        gtagOptions: { debug_mode: isDebugMode },
      },
    ])
  }, [])
}
